import { render, staticRenderFns } from "./UnsuspensionRequests.vue?vue&type=template&id=b1f24992&"
import script from "./UnsuspensionRequests.vue?vue&type=script&lang=js&"
export * from "./UnsuspensionRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports